import { useEffect, useState } from 'react';
// import  CommercialSection  from "./styles/CommercialSection.styled";
import { Footer } from './styles/Footer.styled.js';
import { NavBar } from './styles/NavBar.styled.js';
import InvestingExperience from './styles/InvestingExperience.styled.js';
import whyChoose from './assets/whyChoose.jpg';

import rade_van from './assets/rade_van.png';
import { Accordion, AccordionContent } from './styles/Accordion.styled.js';
import { WhyChooseRade} from './styles/OurColleagues.styled.js';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMinus } from '@fortawesome/free-solid-svg-icons';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { ShowCase } from './styles/ShowCase.styled.js';

// import logo from './assets/rade-color.png';

const Transport = () => {
  //Title Page
  useEffect(() => {
    document.title =
      'Transport - Facilities services for the Transport Industry';
  }, []);




  const [openIndex, setOpenIndex] = useState(null);

  const toggleAccordion = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const items = [
    {
      question: 'What types of goods do you transport?',
      answer:
        'We handle  including client goods, industrial supplies, and specialized freight, ensuring safe and efficient delivery.',
    },
    {
      question: ' What industries do you serve?  ',
      answer:
        'We work with diverse sectors including retail, manufacturing, healthcare, construction, and e‑commerce.',
    },
    {
      question: 'How do you ensure timely delivery?  ',
      answer:
        'We use advanced tracking systems, optimized routing, and dedicated teams to guarantee punctual deliveries.',
    },
    {
      question: 'How do you handle fragile or high‑value items?  ',
      answer:
        'We use specialized packaging, handling protocols, and insurance options to protect sensitive cargo.',
    },
    {
      question: 'Can logistics solutions be customized for my business?  ',
      answer:
        'Definitely. We tailor transportation and supply chain strategies to meet unique business requirements.',
    },
    {
      question: 'How do I book or request a logistics service?  ',
      answer:
        'You can schedule services through our website or contact our customer support team to arrange a plan that fits your needs.',
    },
  ];

  return (
    <>
      <NavBar></NavBar>
      <ShowCase>
        <div className="center">
          <div className="titleBox">
            <h1>Transport</h1>
            <p>
              Ensuring your assets and personal belonging are transitionend
              safely and seamlessly is the primary goal of our relocation
              experts. We provide tailored moving solutions across both
              commercial and domestic sectors.
            </p>
          </div>
        </div>
      </ShowCase>
      <InvestingExperience>
        <div className="container">
          <div className="row">
            <div className="col_2">
              <h1>Driving Efficiency Through Logistics </h1>
              <p>
                At Rade Integrated Services Ltd, we specialize in delivering
                reliable transportation and logistics solutions that keep
                businesses moving. With a commitment to safety, timeliness, and
                innovation, we ensure your goods reach their destination
                seamlessly, every time.
              </p>
            </div>
            <div className="col_1">
              <img src={rade_van} alt="" />
            </div>
          </div>
        </div>
      </InvestingExperience>
      <WhyChooseRade>
        <div className="container">
          <div className="row">
            <div className="col_1">
              <img src={whyChoose} alt="Operation" />
            </div>
            <div className="col_2">
              <h1>Why Choose Rade Integrated? </h1>
              <p>
                With a proven track record and a customer‑first approach, Rade
                Integrated Services Ltd combines expertise, technology, and a
                dedicated team to deliver logistics solutions that empower
                businesses. We don’t just move goods — we move growth.
              </p>
            </div>
          </div>
        </div>
      </WhyChooseRade>
      <Accordion>
        <div className="container">
          <div className="row">
            <h1>Frequently asked questions for Transport</h1>
            <div className="accordion">
              {items.map((item, index) => (
                <div className="accordion-items" key={index}>
                  <button
                    className="accordionButton"
                    onClick={() => toggleAccordion(index)}
                  >
                    <h3>{item.question}</h3>
                    <div className="iconWrapper">
                      {openIndex !== index && (
                        <FontAwesomeIcon icon={faPlus} className="btn" />
                      )}
                      {openIndex === index && (
                        <FontAwesomeIcon icon={faMinus} className="btn" />
                      )}
                    </div>
                  </button>
                  <AccordionContent isOpen={openIndex === index}>
                    <p>{item.answer}</p>
                  </AccordionContent>
                </div>
              ))}
            </div>
          </div>
        </div>
      </Accordion>
      {/* Footer */}
      <Footer></Footer>
    </>
  );
};

export default Transport;
